module.exports = __webpack_public_path__ + "img/Elements_Icons_Market Service.7d917bb9.png";